import { connect } from 'react-redux';
import queryString from 'query-string';

import ComponentList from './ComponentList';

import {
  getSpecialComponents,
  openCreateComponentUI,
} from '../create/createComponent/actions';
import {
  rearrangeComponents,
  rearrangeTabComponents,
  getAllLazyData,
  duplicateComponentDialog,
} from './actions';
import { launchRemoveDialog } from '../remove/actions';
import { loadPageEditorContent } from '../../../../actions';

const mapStateToProps = (state, ownProps) => {
  const { page, tab } = queryString.parse(ownProps.location.search);
  const pageData = state.editor.data.alwaysData[page];
  const freeTrialPlan = state.account.organisation.trial_expired
    ? null
    : 'accelerate';
  const subscription =
    freeTrialPlan || state.app.appContext.subscription || 'start';

  if (!pageData) {
    return {
      ...ownProps,
      subscription,
      loading: true,
    };
  }

  const currentView = tab
    ? pageData.tabs
      ? pageData.tabs[tab]
      : []
    : pageData;

  if (!currentView) {
    return {
      ...ownProps,
      subscription,
      loading: true,
    };
  }

  const componentKeys = currentView.components || [];
  const readyComponents = componentKeys
    .map(key => {
      const always = state.editor.data.alwaysData[key];
      if (!always) return null;

      const lazyData =
        always.lazy_data != null
          ? state.editor.data.lazyData[always.lazy_data]
          : undefined;

      return {
        ...always,
        lazyData,
        key,
        label:
          lazyData && Object.prototype.hasOwnProperty.call(lazyData, 'label')
            ? lazyData.label
            : '',
      };
    })
    .filter(Boolean);

  // Full-page spinner only while nothing can be shown yet.
  // Once any components have hydrated, paint them; remaining ones join as
  // loadPageEditorContent / background sync fills alwaysData (and titles via lazy).
  const waitingForFirstPaint =
    componentKeys.length > 0 && readyComponents.length === 0;

  return {
    ...ownProps,
    ...currentView,
    subscription,
    ...state.editor.build.create.createComponent,
    diyComponents: state.app.addons.diyComponents || {},
    components: readyComponents,
    loading: waitingForFirstPaint,
    isAppSumAccount:
      state.account.organisation.appsumo_id !== '' ? true : false,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  removeComponent: key =>
    dispatch(
      launchRemoveDialog(
        ownProps.match.params.appname,
        {
          ...queryString.parse(ownProps.location.search),
          component: key,
        },
        'COMPONENT',
      ),
    ),
  duplicateComponent: item => dispatch(duplicateComponentDialog(item)),
  rearrangeComponents: (id, siblingId) =>
    dispatch(
      rearrangeComponents(
        id,
        siblingId,
        queryString.parse(ownProps.location.search).page,
        ownProps.match.params.appname,
      ),
    ),
  rearrangeTabComponents: (id, siblingId) =>
    dispatch(
      rearrangeTabComponents(
        id,
        siblingId,
        queryString.parse(ownProps.location.search).tab,
        queryString.parse(ownProps.location.search).page,
        ownProps.match.params.appname,
      ),
    ),

  getAllLazyData: () =>
    dispatch(
      getAllLazyData(
        ownProps.match.params.appname,
        queryString.parse(ownProps.location.search).page,
      ),
    ),
  loadPageEditorContent: page =>
    dispatch(loadPageEditorContent(ownProps.match.params.appname, page)),
  getSpecialComponents: () => dispatch(getSpecialComponents()),
  openCreateComponentUI: label => {
    dispatch(getSpecialComponents());
    dispatch(openCreateComponentUI(label));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ComponentList);
